import { Box, Typography, useTheme } from '@mui/material'
import SearchOffIcon from '@mui/icons-material/SearchOff';

const SinResultados = ({isDarkMode: isDarkModeProp}) => {
    const theme = useTheme();
    const isDarkMode = isDarkModeProp !== undefined ? isDarkModeProp : theme.palette.mode === 'dark';

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 100,
            p: 4,
            background: isDarkMode 
                ? 'linear-gradient(135deg, #1F2A40 0%, #2d3a52 100%)' 
                : 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
            borderRadius: 3,
            border: isDarkMode ? '1px solid #3d4a62' : '1px solid #e0e0e0'
        }}>
            <Box sx={{
                width: 50,
                height: 50,
                borderRadius: '50%',
                background: isDarkMode 
                    ? 'linear-gradient(135deg, #2d3a52 0%, #3d4a62 100%)' 
                    : 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mb: 3,
                boxShadow: isDarkMode 
                    ? '0 4px 12px rgba(0, 0, 0, 0.3)' 
                    : '0 4px 12px rgba(3, 100, 255, 0.15)'
            }}>
                <SearchOffIcon sx={{ fontSize: 30, color: isDarkMode ? '#64B5F6' : '#0364ff' }} />
            </Box>
            <Typography sx={{
                color: isDarkMode ? '#e0e0e0' : '#2d3748',
                fontWeight: 700,
                fontSize: 17,
                mb: 1,
                textAlign: 'center'
            }}>
                No se encontraron resultados
            </Typography>
            <Typography sx={{
                color: isDarkMode ? '#a0a0a0' : '#718096',
                fontSize: 12,
                textAlign: 'center',
                maxWidth: 400,
                lineHeight: 1.6
            }}>
                Intenta con otros términos de búsqueda o verifica la ortografía
            </Typography>
        </Box>
    )
}

export default SinResultados
